export interface ExternalEvGrantBannerProps {
  saving: 3750 | 1500;
  variant: 'government' | 'manufacturer';
}

const ExternalEvGrantBanner = ({
  saving,
  variant,
}: ExternalEvGrantBannerProps) => {
  const BannerCopy = ({ saving, variant }: ExternalEvGrantBannerProps) => {
    switch (variant) {
      case 'government':
        return (
          <>
            Price includes{' '}
            <span className="ch-color--ac-yellow">£{saving}</span> Govt.
            Electric Car Grant
          </>
        );

      case 'manufacturer':
        return (
          <>
            This deal includes{' '}
            <span className="ch-color--ac-yellow">£{saving}</span> manufacturer
            EV&nbsp;grant
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="ac-promo ac-promo--ev-grant ch-bg--ac-black">
      <div className="ch-color--white ch-fw--500 ch-fs--2 sm:ch-fs--3 ch-text--center ch-width--12">
        <BannerCopy saving={saving} variant={variant} />
      </div>
    </div>
  );
};

export default ExternalEvGrantBanner;
